<template>
  <button
    type="button"
    class="wg-toggle"
    :class="{ on: value, small: small }"
    :aria-pressed="value ? 'true' : 'false'"
    :disabled="disabled"
    @click="$emit('input', !value)"
  >
    <span class="knob"></span>
  </button>
</template>

<script>
/** Design-mock switch: ON = success green, OFF = neutral grey. */
export default {
  name: 'WgToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import './wg-tokens.scss';

.wg-toggle {
  width: 44px;
  height: 24px;
  border-radius: 999px;
  border: none;
  background: $pop-switch-off;
  position: relative;
  cursor: pointer;
  flex: none;
  transition: background 0.15s;
  padding: 0;

  .knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    transition: left 0.15s;
  }

  &.on {
    background: $pop-switch-on;

    .knob {
      left: 23px;
    }
  }

  &.small {
    width: 40px;
    height: 20px;

    .knob {
      width: 14px;
      height: 14px;
    }

    &.on .knob {
      left: 23px;
    }
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
}
</style>
